const computedConfiguration = {
  start() {
    return this.$store.getters['chart/getPeriod'].start
  },
  end() {
    return this.$store.getters['chart/getPeriod'].end
  },
  active() {
    return this.$store.getters['chart/getTab'] === this.tabname
  },
  selectedDemandType() {
    return this.$store.getters['chart/getDemandType']
  },
}

const watchConfiguration = {
  end: {
    handler() {
      this.fetchRouteOnActive()
    },
  },
  active: {
    handler() {
      this.fetchRouteOnActive()
    },
  },
  selectedDemandType: {
    handler() {
      this.fetchRouteOnActive()
    },
  },
}

const chartHasMeaningfulData = data => data?.datasets?.some(
  dataset => dataset.data.some(value => value > 0),
)

const BASE_CHART_HEIGHT = 400
const AUGMENTED_CHART_HEIGHT = 2000

const CHART_COLORS = {
  PRIMARY: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FF5733'],

  EXTENDED: [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FF5733',
    '#8BC34A', '#E91E63', '#00BCD4', '#FFC107', '#673AB7', '#FF9800', '#009688',
    '#F44336', '#3F51B5',
  ],

  HOURLY: [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40',
    '#FF5733', '#C9CBCF', '#FF6399', '#36AEEB', '#FFCE99', '#4BC0C0',
    '#9966FF', '#FF9F40', '#E7E9ED', '#C9CBBF', '#FF6322', '#36A2EB',
    '#FFCE56', '#4BC040', '#9966FF', '#FF9F40', '#E7E9ED', '#C9CBCF',
  ],

  BRAND: {
    PRIMARY: '#16B5EA',
    PRIMARY_LIGHT: '#16b5ea70',
    SECONDARY: '#15EB6B',
    ACCENT_ORANGE: '#f08858',
    ACCENT_RED: '#FF6384',
    NEUTRAL: '#C5DAC1',
  },
}

const TABS = {
  CALLS: 'Calls',
  LOCATION: 'Location',
  GENDERAGE: 'GenderAge',
  DEMANDREASON: 'DemandReason',
  NOTORIETY: 'Notoriety',
  ACCOMMODATION: 'Accommodation',
  ACCOMMODATION_REQUEST: 'AccommodationRequest',
  VOLUNTEERSHOURS: 'VolunteersHours',
  CALLINFLUX: 'CallInflux',
}

export {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  AUGMENTED_CHART_HEIGHT,
  chartHasMeaningfulData,
  CHART_COLORS,
  TABS,
}
